import React from "react";
import styles from "./Sidebar.module.css";
import { NavLink } from 'react-router-dom'

import { useReviewContext } from "../../../context/ReviewContext";
import useNavigationGuard from "../../../hooks/useNavigationGuard";
import ReviewExitDialog from "../dialog/reviewExitDialog/ReviewExitDialog";

import { APP_VERSION } from '../../../config';

const Sidebar = () => {
  const { shouldBlockNavigation } = useReviewContext();
  const {
    showDialog,
    handleNavigationAttempt,
    handleConfirm,
    handleCancel
  } = useNavigationGuard(shouldBlockNavigation);

  const handleNavigation = (e, to) => {
    e.preventDefault();
    handleNavigationAttempt(to);
  };

  return (
    <div className={styles["sidebar-container"]}>
      <nav className={styles["navbar"]}>
        <ul>
          <NavLink
            to="/dashboard/open-applications"
            onClick={(e) => handleNavigation(e, "dashboard/open-applications")}
            className={({ isActive }) => {
              const baseClass = styles['nav-link'] || '';
              const activeClass = isActive ? styles.active : '';
              return `${baseClass} ${activeClass}`.trim();
            }}>
            <li className={styles["nav-item-custom"]}>Open Applications</li>
          </NavLink>

          <NavLink
            to="/dashboard/closed-applications"
            onClick={(e) => handleNavigation(e, "/dashboard/closed-applications")}
            className={({ isActive }) => {
              const baseClass = styles['nav-link'] || '';
              const activeClass = isActive ? styles.active : '';
              return `${baseClass} ${activeClass}`.trim();
            }}
          >
            <li className={styles["nav-item-custom"]}>Closed Applications</li>
          </NavLink>

          <NavLink
            to="/dashboard/analytics"
            onClick={(e) => handleNavigation(e, "/dashboard/analytics")}
            className={({ isActive }) => {
              const baseClass = styles['nav-link'] || '';
              const activeClass = isActive ? styles.active : '';
              return `${baseClass} ${activeClass}`.trim();
            }}
          >
            <li className={styles["nav-item-custom"]}>Analytics</li>
          </NavLink>
        </ul>

        <div className={styles["nav-footer"]}>
          <span className={styles["nav-footer-text"]}>Review Center v{APP_VERSION}</span>
        </div>
      </nav>

      <ReviewExitDialog
        isOpen={showDialog}
        onClose={handleCancel}
        onConfirm={handleConfirm}
      />
    </div >
  );
};

export default Sidebar;
